import { Routes } from '@angular/router';
import { Login } from './login/login';
import { Main } from './main/main';
import { authGuard, guestGuard } from './auth-guard';
import { mainRoutes } from './main/main.routes';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy-component';

export const routes: Routes = [
  { path: '', redirectTo: 'main', pathMatch: 'full' },
  { path: 'login', component: Login, canActivate: [guestGuard] },
  { path: 'main', component: Main, canActivate: [authGuard], children: mainRoutes  },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: '**', redirectTo: 'main' }
];